import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class DistributorPriceListService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public SavePrices(values: any[]) {
        return this.baseApiFactory.post('/api/DistributorPriceList/SavePrices', values);
    }

    public SavePriceListForAll(value: any) {
        return this.baseApiFactory.post('/api/DistributorPriceList/SavePriceListForAll', value);
    }

    public SaveMascotPriceForAll(value: any) {
        return this.baseApiFactory.post('/api/DistributorPriceList/SaveMascotPriceForAll', value);
    }

    public GetAvailableProducts(query: string) {
        return this.baseApiFactory.get<any[]>(`/api/DistributorPriceList/GetAvailableProducts?${query}`);
    }
}

lazyRegister.service('DistributorPriceListService', DistributorPriceListService);